import LegalPage, { LegalSection, LP } from "@/components/LegalPage";

export default function TermsPage() {
  return (
    <LegalPage
      title="Conditions Générales de Vente et d'Utilisation"
      subtitle="Les présentes conditions régissent l'utilisation de la plateforme Zevents et la vente de billets, la collecte de fonds, les bons d'achat et les autres services proposés."
      updated="16 juin 2026"
      testId="cgv-page"
    >
      <LegalSection id="objet" title="1. Objet">
        <LP>
          Les présentes Conditions Générales de Vente et d'Utilisation (les « <strong>CGV</strong> ») ont pour objet
          de définir les modalités et conditions dans lesquelles <strong>Zevents</strong> (la « <strong>Plateforme</strong> »),
          éditée par <strong>ALO FINANCES</strong>, met à disposition ses services et encadre les relations entre la
          Plateforme, les organisateurs d'événements (les « <strong>Organisateurs</strong> ») et les utilisateurs
          (les « <strong>Utilisateurs</strong> » ou « <strong>Acheteurs</strong> »), qu'ils disposent ou non d'un compte.
        </LP>
        <LP>
          La Plateforme agit en qualité d'<strong>intermédiaire technique</strong> mettant en relation les Organisateurs
          et les Utilisateurs. Elle n'est ni l'organisateur des événements, ni le bénéficiaire des cagnottes, ni
          l'émetteur des bons d'achat, sauf mention contraire expresse.
        </LP>
      </LegalSection>

      <LegalSection id="editeur" title="2. Éditeur de la Plateforme">
        <LP>
          <strong>Dénomination :</strong> ALO FINANCES, société éditrice de la plateforme Zevents (« zevents by ALO FINANCES »).<br />
          <strong>Forme juridique :</strong> SA (Société Anonyme) &nbsp;·&nbsp; <strong>Immatriculation (RCCM / NINEA) :</strong> [À COMPLÉTER]<br />
          <strong>Siège social :</strong> [À COMPLÉTER] — République de Guinée &nbsp;·&nbsp; <strong>Contact :</strong> support@alofinances.com
        </LP>
      </LegalSection>

      <LegalSection id="acceptation" title="3. Acceptation des conditions">
        <LP>
          Toute utilisation de la Plateforme (création de compte, achat de billet, contribution à une cagnotte,
          réclamation d'un bon d'achat, participation à un vote ou un sondage, y compris en mode invité) implique
          l'acceptation pleine et entière des présentes CGV. Si vous n'acceptez pas ces conditions, vous devez
          renoncer à utiliser la Plateforme.
        </LP>
      </LegalSection>

      <LegalSection id="compte" title="4. Compte utilisateur et mode invité">
        <LP>
          Certaines actions peuvent être réalisées <strong>sans compte (mode invité)</strong> en fournissant un nom,
          un e-mail et, le cas échéant, un numéro de téléphone. La création d'un compte permet de retrouver ses
          billets, son historique et de gérer ses préférences.
        </LP>
        <LP>
          L'Utilisateur garantit l'exactitude des informations communiquées et est responsable de la confidentialité
          de ses identifiants. Tout compte créé avec des informations fausses ou usurpées pourra être suspendu.
        </LP>
      </LegalSection>

      <LegalSection id="services" title="5. Description des services">
        <LP>La Plateforme propose notamment :</LP>
        <ul style={{ margin: "0 0 12px", paddingLeft: 20 }}>
          <li><strong>Billetterie</strong> : vente de billets d'événements avec billet électronique et QR code.</li>
          <li><strong>Cagnottes</strong> : collecte de fonds pour des projets, causes ou événements.</li>
          <li><strong>Bons d'achat</strong> : émission et utilisation de bons auprès de commerçants partenaires.</li>
          <li><strong>Votes et sondages</strong> : consultations en ligne.</li>
          <li><strong>Listes de cadeaux</strong> : réservation et participation à des cadeaux.</li>
        </ul>
      </LegalSection>

      <LegalSection id="obligations-organisateur" title="6. Obligations des Organisateurs">
        <LP>
          L'Organisateur est seul responsable du contenu qu'il publie, de la réalité, de la légalité et du bon
          déroulement de son événement, de sa cagnotte ou de ses bons d'achat, ainsi que du respect de la
          réglementation applicable (autorisations, sécurité, fiscalité, droits d'auteur, etc.). Il garantit la
          Plateforme contre toute réclamation de tiers liée à son activité.
        </LP>
      </LegalSection>

      <LegalSection id="interdits" title="7. Contenus et activités strictement interdits">
        <LP>
          Afin de protéger les Utilisateurs et de garantir un usage éthique et légal de la Plateforme, sont
          <strong> formellement interdits</strong>, sans que cette liste soit limitative :
        </LP>
        <ul style={{ margin: "0 0 12px", paddingLeft: 20 }}>
          <li>
            <strong>Collectes de fonds (cagnottes)</strong> au profit, direct ou indirect, d'une organisation, d'une
            personne ou d'un événement lié à une activité criminelle, terroriste, au blanchiment d'argent, au
            financement d'activités illégales ou à toute infraction pénale.
          </li>
          <li>
            <strong>Bons d'achat</strong> portant sur des <strong>substances illicites ou stupéfiants (drogues)</strong>,
            sous quelque forme que ce soit.
          </li>
          <li>
            <strong>Bons d'achat</strong> portant sur l'<strong>alcool</strong> ou le <strong>tabac</strong> (et produits
            dérivés tels que cigarettes, cigarettes électroniques, chicha, etc.).
          </li>
          <li>
            <strong>Billetterie</strong> pour des <strong>événements immoraux</strong>, à caractère pornographique,
            dégradant, incitant à la haine, à la violence, à la discrimination, ou contraires à l'ordre public et aux
            bonnes mœurs.
          </li>
          <li>
            Tout contenu portant atteinte aux droits de tiers, aux mineurs, ou faisant la promotion d'armes,
            de contrefaçons ou de toute activité interdite par la loi.
          </li>
        </ul>
        <LP>
          La Plateforme se réserve le droit, à tout moment et sans préavis, de <strong>refuser, suspendre, dépublier
          ou supprimer</strong> tout événement, cagnotte, bon d'achat ou compte contrevenant à ces règles, de
          retenir les fonds concernés et, le cas échéant, de signaler les faits aux autorités compétentes.
        </LP>
      </LegalSection>

      <LegalSection id="prix-paiement" title="8. Prix et paiement">
        <LP>
          Les prix sont indiqués en <strong>Francs guinéens (GNF)</strong>, sauf indication contraire, et fixés par
          l'Organisateur. Les paiements sont traités via un <strong>prestataire de paiement agréé</strong>. La Plateforme
          n'a pas accès aux données bancaires complètes, qui sont gérées par le prestataire dans un environnement
          sécurisé. Des frais de service peuvent s'appliquer et sont, le cas échéant, affichés avant la validation.
        </LP>
      </LegalSection>

      <LegalSection id="billets" title="9. Billets et accès à l'événement">
        <LP>
          Après paiement, un billet électronique (QR code) est délivré et envoyé par e-mail et/ou SMS. Ce billet est
          personnel ; sa reproduction frauduleuse est interdite. L'accès à l'événement relève de la seule
          responsabilité de l'Organisateur, qui peut contrôler la validité des billets à l'entrée.
        </LP>
      </LegalSection>

      <LegalSection id="cagnottes" title="10. Cagnottes et collecte de fonds">
        <LP>
          Les contributions à une cagnotte sont des engagements volontaires au profit du porteur de projet. La
          Plateforme ne garantit pas l'usage des fonds par l'Organisateur. Les cagnottes contraires à l'article 7
          sont interdites et seront retirées.
        </LP>
      </LegalSection>

      <LegalSection id="bons" title="11. Bons d'achat">
        <LP>
          Les bons d'achat sont utilisables selon les conditions définies par le commerçant émetteur (durée de
          validité, périmètre, montant). Les bons portant sur des produits interdits (article 7) ne sont pas autorisés.
        </LP>
      </LegalSection>

      <LegalSection id="annulation" title="12. Annulation, report et remboursement">
        <LP>
          En cas d'annulation ou de report d'un événement, les modalités de remboursement relèvent de la
          responsabilité de l'Organisateur, dans le respect de la réglementation applicable. La Plateforme facilite,
          dans la mesure du possible, la mise en relation et le traitement des demandes mais ne saurait se substituer
          à l'Organisateur défaillant.
        </LP>
      </LegalSection>

      <LegalSection id="responsabilite" title="13. Responsabilité">
        <LP>
          La Plateforme intervient comme intermédiaire technique. Sa responsabilité ne saurait être engagée du fait
          du contenu publié par les Organisateurs, du déroulement des événements, de l'usage des fonds collectés ou
          des bons d'achat. La Plateforme met en œuvre les moyens raisonnables pour assurer la disponibilité et la
          sécurité du service, sans garantie d'absence d'interruption.
        </LP>
      </LegalSection>

      <LegalSection id="pi" title="14. Propriété intellectuelle">
        <LP>
          La marque Zevents, son identité visuelle (« zevents by ALO FINANCES »), ses contenus et ses développements
          sont protégés. Toute reproduction non autorisée est interdite. Les Organisateurs concèdent à la Plateforme
          le droit d'afficher leurs contenus (logos, visuels, descriptions) aux fins de fourniture du service.
        </LP>
      </LegalSection>

      <LegalSection id="donnees" title="15. Données personnelles">
        <LP>
          Le traitement des données personnelles est décrit dans la{" "}
          <a href="/confidentialite" className="z-link">Politique de confidentialité</a>, qui fait partie intégrante
          des présentes CGV.
        </LP>
      </LegalSection>

      <LegalSection id="moderation" title="16. Modération et suspension">
        <LP>
          La Plateforme peut modérer les contenus et suspendre ou résilier tout compte en cas de violation des
          présentes CGV, notamment de l'article 7, sans préjudice de tout recours.
        </LP>
      </LegalSection>

      <LegalSection id="modification" title="17. Modification des CGV">
        <LP>
          La Plateforme peut modifier les présentes CGV à tout moment. La version applicable est celle en vigueur à
          la date d'utilisation du service. Les Utilisateurs sont invités à les consulter régulièrement.
        </LP>
      </LegalSection>

      <LegalSection id="droit" title="18. Droit applicable et litiges">
        <LP>
          Les présentes CGV sont régies par le droit en vigueur en <strong>République de Guinée</strong> (Conakry).
          En cas de litige, une solution amiable sera recherchée en priorité
          (contact : support@alofinances.com). À défaut, les tribunaux compétents seront ceux du ressort du siège de
          l'éditeur.
        </LP>
      </LegalSection>
    </LegalPage>
  );
}
